import { useSelector } from "react-redux";
import React from "react";

function ReturnVehicleType({ vt }) {
  // 1) Data
  const ApplicationSettings = useSelector(
    (state) => state.ApplicationSettings.value
  );

  // 3) Fucntions
  let vehicleName = vt;
  let vt_without_POS = ApplicationSettings.Code_for_POS; // Taxiplon -8 get it from config
  let vt_from_Hotel = ApplicationSettings.Car_Type_Code_To_Show_Hotel; // Taxiplon -1

  try {
    let filter1 = ApplicationSettings.CarTypesArray.filter((e) => e.code == vt);
    let filter2 = ApplicationSettings.CarTypesArray.filter(
      (e) => e.code == vt - vt_without_POS
    );
    let filter3 = ApplicationSettings.CarTypesArray.filter(
      (e) => e.code == vt - vt_from_Hotel
    );

    if (filter1[0] !== undefined) {
      vehicleName = filter1[0].name;
    } else if (filter2[0] !== undefined) {
      vehicleName = filter2[0].name;
    } else if (filter3[0] !== undefined) {
      vehicleName = filter3[0].name;
    }
  } catch (error) {
    console.log("ERROR :", error);
  }

  return <>{vehicleName}</>;
}

export default ReturnVehicleType;
